import * as React from "react";
import { CloseCross } from "../CloseCross";
import "./header.scss";

export interface HeaderProps {
  className?: string;
  size?: "sm" | "lg" | "hg";
  as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  onClick?: () => void;
  withCloseButton?: boolean;
  subtext?: string;
}

export const Header: React.FC<HeaderProps> = ({ className, size, as, children, onClick, withCloseButton, subtext }) => {
  const headerTagName = as || "h1";
  const headerDisplaySize = size || "lg";

  return (
    <div className={`c-header ${className || ""}`} data-testid="header-component">
      {React.createElement(headerTagName, { className: `c-header__text--${headerDisplaySize}` }, children)}

      {subtext && React.createElement("p", { className: "c-header__subtext" }, subtext)}
      {withCloseButton !== false && (
        <button className="c-header__close" type="button" onClick={onClick} data-testid="header-close-button">
          <CloseCross />
        </button>
      )}
    </div>
  );
};
